import Vue from 'vue';
import { Task } from '@/interfaces/Task';
import getHours from '@/mixins/utils/getHours';
import add2HoursToLocalDate from '@/mixins/utils/add2HrsToLocalDate';

interface Assignee {
  email: string;
  fullName: string;
}

const endings = [[11, 'st'], [12, 'nd'], [13, 'rd']];

export default Vue.extend({
  methods: {
    getOrdinalSuffix(amtOfUpdates: number): string {
      const [avoid, ending] = endings[(amtOfUpdates % 10) - 1] ?? [undefined, 'th'];
      if (amtOfUpdates % 100 !== avoid) return `${amtOfUpdates}${ending}`;
      return `${amtOfUpdates}th`;
    },
    minutesLeftToEdit(createDate: string) {
      const now = this.$moment();
      const dateExp = add2HoursToLocalDate(createDate);
      const [hrs, message] = getHours(now, dateExp);
      return `${message}${dateExp.subtract(hrs, 'hours').diff(now, 'minutes')}m`;
    },
    canEdit(createDate: string): boolean {
      return !(add2HoursToLocalDate(createDate).diff(this.$moment(), 'minutes') < 0);
    },
    getTaskNotificationText(
      task: Task,
      subName: string,
      verb: string = 'passed off',
      recipient?: string,
    ): string {
      const assignee = recipient
      || ((task.assignees[0] as Assignee)?.fullName ?? task.assignees[0]);
      const endString = assignee ? '/'.concat(assignee) : '';
      return `You ${verb} a task for ${subName}${endString}`;
    },
  },
});
